module.exports = __webpack_public_path__ + "static/media/tyg-logo.bf0f0a23.svg";